<template>
  <div class="sdk_body markdown-body">
    <div id="sdk_toc_wrapper"></div>
    <div class="sdk_content">
      <div class="sdk_position">
        <p>您现在的位置: 开发支持 > {{ nameList[nameEn] }}</p>
      </div>
      <vue-markdown
        class="mark_content"
        :source="md"
        :toc-first-level="1"
        :toc-last-level="6"
        :toc="true"
        :toc-anchor-link="false"
        toc-id="sdk_toc_wrapper"
      ></vue-markdown>
    </div>
  </div>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import axios from 'axios';
import config from '@/config'
import {mapState} from 'vuex'
export default {
  name: 'MyMarkdown',
  components: {
    VueMarkdown,
  },
  props: {
    nameEn: {
      type: String,
    },
  },
  computed: {
    ...mapState(['nameList'])
  },
  data() {
    return {
      md: '',
    };
  },
  created() {
    // 从后端请求README.md
    // console.log(this.$props.requestApi);
    axios
      .get(`${config.baseUrl}/api/console/docs/${this.$props.nameEn}?Authorization=111`)
      .then((res) => {
        // console.log('data',res.data);
        this.md = res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
};
</script>
<style lang="scss" scoped>
@import '../../common/github.css';
.sdk_body {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 100px;
  #sdk_toc_wrapper {
    font-size: 14px;
    font-weight: 300;
    color: #010101;
    background: #f7fafc;
    margin-right: 30px;
    min-width: 400px;
    &::v-deep {
      .table-of-contents {
        padding: 20px;
        li {
          white-space: normal;
          list-style-position: inside;
          margin-top: 15px;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
  .sdk_content {
    min-width: calc(100% - 400px);
    .sdk_position {
      font-size: 14px;
      font-weight: 300;
      color: #888888;
      border-bottom: 1px solid #e7e7e7;
    }
    .mark_content {
      box-sizing: border-box;
      margin-top: 20px;
      height: 1000px;
      overflow-y: scroll;
    }
    &::v-deep {
      p {
        font-size: 14px;
        color: #40485b;
        // margin-bottom: 10px;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: #40485b;
        // margin-top: 30px;
        // margin-bottom: 18px;
      }
    }
  }
}
</style>
